import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'

import Config from "composer/Config.jsx"
import Localization from "composer/Localization.jsx"
import SubmissionDetailAnswer from "composer/views/retriever/SubmissionDetailAnswer.jsx"

import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Switch,
  FormControlLabel,
  List,
} from '@material-ui/core';

class SubmissionDetailHotspot extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      hotspotData: this.props.hotspotData,
      answerDataList: props.answerDataList,
      showAllAnswers: false,
    };
    autoBind(this);
  }

  getComponentById(componentId) {
    let componentList = this.state.hotspotData['component_list'];
    for (let i = 0; i < componentList.length; i++) {
      if (componentList[i].id == componentId) {
        return componentList[i];
      }
    }

    return null;
  }

  render() {
    var showViewMore = false;

    return (
      <div>
        <Card style={{margin:"0 16px 16px 0"}}>
          <CardHeader
            title={this.state.hotspotData['name']}
            subheader={
              <If condition={showViewMore}>
                <Then>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.showAllAnswers}
                        onChange={this.onShowAllToggle}
                      />
                    }
                    label={Localization.strings.SHOW_ALL_ATTEMPTS}
                  />
                </Then>
              </If>
            }
          />
          <CardContent>
            <If condition={this.state.answerDataList.length == 0}>
              <Then>
                <Divider/>
                <br/>
                {Localization.strings.NO_ANSWER}
              </Then>
              <Else>
                {this.state.answerDataList.map( (row, i) => {
                  if (this.getComponentById(row.component_id) != null && row.kind >= Config.HOTSPOT_CONTENT_MC_OF_TEXTS) {
                    return [
                      <Divider/>,
                      <List>
                        <SubmissionDetailAnswer parent={this} root={this.props.root}
                          componentData={this.getComponentById(row.component_id)}
                          answerData={row}
                          showCompareButton={true}
                          showUserName={false}
                          key={row['id']}
                        />
                      </List>,
                    ];
                  }
                })}
              </Else>
            </If>
          </CardContent>
        </Card>
      </div>
    )
  }
}

export default SubmissionDetailHotspot;
